// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchComponent_search__Ljnoa"};